/**
 * When the inspection flow shows the BMP-map gate.
 *
 * Jim (2026-10-07): the ask for an updated map "should not be asked until at
 * least 4 inspections have been conducted. Should never ask the first
 * inspection... only weekly/routine inspections should be counted." The API
 * counts routine visits since the last map and reports `due`; an older API
 * without it falls back to the monthly rule (`satisfied`).
 */
export type BmpGateStatus = {
  satisfied: boolean;
  due?: boolean;
  routine_since_map?: number;
  ask_every?: number;
};

export function isBmpGateNeeded(status: BmpGateStatus | undefined): boolean {
  if (!status) return false;
  return typeof status.due === 'boolean' ? status.due : !status.satisfied;
}
